module.exports = __webpack_public_path__ + "static/media/Matheson Street, Healdsburg, CA3.400fd35c.jpg";